import {h, Fragment, Component} from "preact";
import {route} from "preact-router";
import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as P from "../mobile-templates/event.jsx";
import {groupMarketsByName} from "./prematch-event.jsx";

import FullSite from "./full-site";
import {LiveTrackerByEventPanel} from "../desktop-components/live-event";


export default function LiveEvent(props) {
	return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit"><LiveEventPage {...props} /></FullSite>
}

export class LiveEventPage extends Component {
	componentWillMount() {
		LFeed.onUpdate(this.updateFn = () => {
			this.setState({})
		})
	}
	componentDidUnmount() {
		LFeed.stopUpdate(this.updateFn)
	}
	render({eventId}) {
		if (LFeed.menu == null)
			return null;
		const event = LFeed.getEvent('/event/'+eventId);
		if (event == null)
			return null; // Torna al menu
		const tournament = LFeed.getTournament(event.parent);
		const sport = LFeed.menu[tournament.parent];
		return <LiveEventContent eventId={event.id} tournament={tournament} sport={sport}  />
	}
}

export class TabBasedContent extends Component {
	state = {
		currentTab: -1
	};

	getCurrentTab(event) {
		if (typeof this.state.currentTab === 'undefined') {
			this.state.currentTab = -1;
		}

		if (this.state.currentTab != -1)
			return {id:this.state.currentTab};
		const tabs = this.extractTabs(event);
		return tabs[1] || tabs[0];
	}
	extractTabs(event) {
		const tabs = {};
		for (let market of Object.values(event.sub)) {
			for (let category of market.categories)
				tabs[category.id] = category
		}
		return Object.values(tabs).sort((a, b) => a.id - b.id);
	}
	getMarketsToDisplay(event) {
		if (!event)
			return [];
		const currentTab = this.getCurrentTab(event);
		return Object.values(event.sub)
			.filter(market => market.categories.find(tab => tab.id == currentTab.id))
	}
}

export class LiveEventContent extends TabBasedContent {
	state = {
		showTracker: true
	};

	componentWillMount() {
		LFeed.setTopic(this.props.eventId.split('/').slice(-1)[0])
	}
	componentDidUnmount() {
		LFeed.setTopic('menu')
	}
	render({eventId, sport, tournament}) {
		const event = LFeed.getEvent(eventId);
		const currentTab = this.getCurrentTab(event);
		const markets = this.getMarketsToDisplay(event)
		const odds = groupMarketsByName(markets);
		
		return <Fragment>
			<P.EventHeader {...{sport, category: null, tournament}} onClose={() => {window.history.back()}} />
			<P.EventName>{event.home} - {event.away}</P.EventName>
			<P.EventInfoRow>
				<P.EventInfoCell>{event.status.phase}</P.EventInfoCell>
				<P.EventInfoCell>{event.status.timer ? event.status.timer+"'" : 'LIVE'}</P.EventInfoCell>
			</P.EventInfoRow>
			<P.LiveEventNameLarge event={event} />
			<P.EventInfoRow>
				<a href="javascript:void(0);" onClick={() => this.setState({showTracker: !this.state.showTracker})} class="block w-full text-center p-2">
					<i class={"fa "+ (this.state.showTracker? 'fa-chevron-up' : 'fa-chevron-down')} />
				</a>
			</P.EventInfoRow>
			{!!event && !!this.state.showTracker && <LiveTrackerByEventPanel event={event} />}
			<P.TabsHScrollContainer>
				{this.extractTabs(event).map(tab => 
					<P.SingleEventTab selected={currentTab.id == tab.id} onClick={() => this.setState({currentTab: tab.id})}>
						{tab.name}
					</P.SingleEventTab>
				)}
			</P.TabsHScrollContainer>
			<P.EventMarketsMarketGroup>
				{odds.map((marketGroup, idx) => 
					<CollapsibleMarket key={currentTab.id+marketGroup.name} open={idx < 3} marketGroup={marketGroup} />
				)}
			</P.EventMarketsMarketGroup>
			<P.FakeSeparator />
		</Fragment>
	}
}

export class CollapsibleMarket extends Component {
	state = {
		open: false,
		wasOpen: false
	};
	componentWillMount() {
		this.setState({
			open: !!this.props.open,
			wasOpen: !!this.props.open
		})
	}
	render({marketGroup}) {
		const marketGroupName = marketGroup.sub.length == 1 ? marketGroup.sub[0].name : marketGroup.name;
		return <P.MarketGroup>
			<P.MarketGroupHeader open={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				{marketGroupName}
			</P.MarketGroupHeader>
			{this.state.wasOpen && <P.MarketCollapsingElem open={this.state.open}>
				{marketGroup.sub.map(market => <P.MarketGroupOdds cols={Object.keys(market.sub).length}>
					{Object.values(market.sub).map(outcome => {
						return <P.MarketGroupOddButton 
								   outcome={outcome} 
								   selected={Ticket.hasLiveOdds(outcome.id)}
								   onClick={() => Ticket.toggleLiveOdds(outcome.id)} />
					})}
				</P.MarketGroupOdds>)}
			</P.MarketCollapsingElem>}
		</P.MarketGroup>
	}
}
